export const LOADERS_ACTIONS = {
  START: 'START_LOADING',
  STOP: 'STOP_LOADING',
};

export const LOADERS = {
  GLOBAL: 'GLOBAL',
  JUDGEMENT_ADD: 'JUDGEMENT_ADD',
  JUDGEMENT_ADD_APPEAL: 'JUDGEMENT_ADD_APPEAL',
  EXPERT_REPORT: 'EXPERT_REPORT',
  EXPERT_REPORT_APPEAL: 'EXPERT_REPORT_APPEAL',
  JUDGEMENT_ON_MERITS: 'JUDGEMENT_ON_MERITS',
  MULTIPLE_JUDGEMENT_ON_MERITS: 'MULTIPLE_JUDGEMENT_ON_MERITS',
  DAHIR_CORPO: 'DAHIR_CORPO',
  DAHIR_AMOUNT: 'DAHIR_AMOUNT',
  FEE_NOTE: 'FEE_NOTE',
  NOTIFICATION: 'NOTIFICATION',
  NOTIFICATION_INBOXES: 'NOTIFICATION_INBOXES',
  TRACKING_USER: 'TRACKING_USER',
  PROVISIONAL_CLAIM_DETAILS: 'PROVISIONAL_CLAIM_DETAILS',
};
